// extracted by mini-css-extract-plugin
export default {"card":"LandingPageMainCard_card__ob4R6"};